import { createSlice } from '@reduxjs/toolkit';

export const VIDEO_CALL_SLICE_NAME = 'videoCall';

export interface VideoCallState {
  /** Count updated immediately after a successful add-to-video-call-cart.
   *  -1 means "never added this session" — fall back to server-provided count. */
  sessionActiveCount: number;
}

const initialState: VideoCallState = {
  sessionActiveCount: -1,
};

const videoCallSlice = createSlice({
  name: VIDEO_CALL_SLICE_NAME,
  initialState,
  reducers: {
    setVideoCallActiveCount(state, action: { payload: number }) {
      state.sessionActiveCount = action.payload;
    },
  },
});

export const videoCallReducer = videoCallSlice.reducer;
export const { setVideoCallActiveCount } = videoCallSlice.actions;

export function selectVideoCallSessionActiveCount(state: {
  [VIDEO_CALL_SLICE_NAME]?: VideoCallState;
}): number {
  return state[VIDEO_CALL_SLICE_NAME]?.sessionActiveCount ?? -1;
}
